module.exports = require("./sr-Cyrl-BA.d.ts");